<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: 'GlobalIndex',
    data: function () {
      return {
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
